/**
 * IDs canónicos de reguladores — convención de ARS93 entre ciudades.
 * Santa Coloma de Gramenet usa el prefijo "SCG" + 3 dígitos con ceros.
 *
 *   logicalId 94  →  canónico "SCG094"  →  visual "094"
 *
 * El canónico se usa en topics/payloads MQTT y como mapeo interno de la
 * organización. El visual es lo único que se muestra en pantalla.
 */

const CITY_PREFIX = 'SCG';

/** ID canónico de organización (p. ej. "SCG094"). Para topics y payloads MQTT. */
export function toCanonicalId(logicalId: number): string {
  return CITY_PREFIX + String(logicalId).padStart(3, '0');
}

/** ID visible en pantalla (p. ej. "094"): 3 dígitos, sin prefijo de ciudad. */
export function toDisplayId(logicalId: number): string {
  return String(logicalId).padStart(3, '0');
}

/** Canónico → visual ("SCG094" → "094"). null si no es un ID de esta ciudad:
 *  lo usa el asistente, que puede nombrar un regulador que no existe aquí. */
export function canonicalToDisplayId(canonical: string): string | null {
  const m = new RegExp(`^${CITY_PREFIX}(\\d{3,4})$`, 'i').exec(canonical.trim());
  return m ? m[1] : null;
}
